
<template>
    <v-container class="form-container">
        <formulario-cadastro @sucesso="handleSucessoFormulario" @falha="handleFalhaFormulario" :cpf="cpf" :nome-empresa="nome_empresa" :client-id="client_id" :client-secret="client_secret" :logo="logo"></formulario-cadastro>
    </v-container>
</template>

<script>
  import FormularioCadastro from '@/components/cadastro-externo/FormularioCadastro.vue'
  import { flavorRes, loadFlavor } from '@/plugins/flavors'

  export default {
    name: 'CadastroUsuarioExterno',
    components: { FormularioCadastro },
    data () {
      return {
        cpf: '',
        nome_empresa: '',
        client_id: '',
        client_secret: '',
        logo: ''
      }
    },
    created () {
      const { nome_empresa, client_id, client_secret, cpf, flavor } = this.$route.params

      loadFlavor(flavor)
      this.logo = flavorRes('img/logo-menu.png')
      this.nome_empresa = nome_empresa
      this.client_id = client_id
      this.client_secret = client_secret
      this.cpf = atob(cpf)
    },
    methods: {
      handleSucessoFormulario () {
        this.$router.push({ name: 'autentica_usuario_externo', params: { 'sucesso_no_formulario': true } })
      },
      handleFalhaFormulario () {
        this.$router.push({ name: 'autentica_usuario_externo', params: { 'falha_no_formulário': true } })
      }
    }
  }
</script>

<style scoped lang="scss">
.form-container{
  max-width: 1000px;
}

</style>
